import HttpService from "./htttp.service";

export const setupAxiosInterceptors = (onUnauthenticated) => {
  const onRequestSuccess = async (config) => {
    // 🚫 Public routes: don't attach auth token
    const isPublicRoute =
      config.url.includes("/karkuns/device-verify") ||
      config.url.includes("/attendance/karkun-attendance-verify");

    if (isPublicRoute) {
      return config; // skip adding Authorization header
    }

    // 🔐 Private routes: attach token
    const token = localStorage.getItem("authToken");
    if (token) {
      const authToken = JSON.parse(token);
      config.headers.Authorization = `Bearer ${authToken.access_token}`;
    }

    return config;
  };

  const onRequestFail = (error) => Promise.reject(error);

  HttpService.addRequestInterceptor(onRequestSuccess, onRequestFail);

  const onResponseSuccess = (response) => response;

  const onResponseFail = (error) => {
    const status = error.status || error.response?.status;

    if (status === 430) {
      // Device already registered / already used
      console.warn("Device or attendance conflict:", error.response?.data?.message || error.message);
      return Promise.reject(error); // Let frontend handle user-facing message
    }

    // 🔹 Ignore unauthenticated errors for public QR routes
    const isPublicRoute =
      error.config?.url?.includes("/karkuns/device-verify") ||
      error.config?.url?.includes("attendance/karkun-attendance-verify");

    if ((status === 403 || status === 401) && !isPublicRoute) {
      onUnauthenticated();
    }

    return Promise.reject(error);
  };

  HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);
};
